import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { toJS } from 'mobx';
import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
const GLAccount = types.model('GLAccount', {
  externalId: types.maybeNull(types.string),
  accountName: types.maybeNull(types.string),
  accountType: types.maybeNull(types.string),
  lastUpdatedAt: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  number: types.maybeNull(types.string),
  type: types.maybeNull(types.string)
});
const UtilityGlAccountsUnit = types.model('UtilityGlAccountsUnit', {
  propertyUtilityLivableId: types.maybeNull(types.string),
  glAccountExternalId: types.maybeNull(types.string)
});
export const glCodeSetupModel = types.model('glCodeSetupModel', {
  isLoaded: types.optional(types.boolean, false),
  glAccounts: types.optional(types.array(GLAccount), []),
  glAccountsStored: types.optional(types.array(GLAccount), []),
  utilityGlAccounts: types.optional(types.array(UtilityGlAccountsUnit), []),
  utilityGlAccountsStored: types.optional(types.array(UtilityGlAccountsUnit), []),
  rentGlAccountExternalId: types.optional(types.maybeNull(types.string), null),
  adminFeeGlAccountExternalId: types.optional(types.maybeNull(types.string), null),
  paperStatementFeeGlAccountExternalId: types.optional(types.maybeNull(types.string), null),
  glAccountExternalId: types.optional(types.maybeNull(types.string), null),
  //default
  chargeOnDayOfMonth: types.optional(types.maybeNull(types.number), null)
}).views(store => ({
  utilityGlAccountsPatchSemanticallyEqual() {
    const norm = arr => [...toJS(arr)].map(i => {
      var _i$propertyUtilityLiv, _i$glAccountExternalI;
      return {
        id: (_i$propertyUtilityLiv = i.propertyUtilityLivableId) !== null && _i$propertyUtilityLiv !== void 0 ? _i$propertyUtilityLiv : '',
        gl: (_i$glAccountExternalI = i.glAccountExternalId) !== null && _i$glAccountExternalI !== void 0 ? _i$glAccountExternalI : null
      };
    }).sort((a, b) => a.id.localeCompare(b.id));
    return JSON.stringify(norm(store.utilityGlAccountsStored)) === JSON.stringify(norm(store.utilityGlAccounts));
  },
  getUtilityGlAccountsValueForPatch() {
    const prevArr = toJS(store.utilityGlAccountsStored);
    const currArr = toJS(store.utilityGlAccounts);
    const prevMap = new Map(prevArr.map(i => [i.propertyUtilityLivableId, i.glAccountExternalId]));
    const prevIds = new Set(prevArr.map(i => i.propertyUtilityLivableId).filter(Boolean));
    const currIds = new Set(currArr.map(i => i.propertyUtilityLivableId).filter(Boolean));
    const hadRemoval = [...prevIds].some(id => !currIds.has(id));
    const delta = currArr.filter(c => prevMap.get(c.propertyUtilityLivableId) !== c.glAccountExternalId);
    if (hadRemoval) {
      return currArr;
    }
    return delta.length ? delta : currArr;
  }
})).actions(store => {
  let afterLoadState;
  return {
    initAfterLoadState() {
      try {
        afterLoadState = getSnapshot(store);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    applyAfterLoadState() {
      try {
        applySnapshot(store, afterLoadState);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setGlAccounts(data) {
      try {
        store.glAccounts = data;
        store.glAccountsStored = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    searchGlAccounts(searchValue) {
      try {
        const searchResp = [];
        store.glAccountsStored.map(i => {
          if (i.name.toLocaleLowerCase().includes(searchValue.trim().toLocaleLowerCase())) {
            searchResp.push(toJS(i));
          }
        });
        store.glAccounts = searchResp;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    handleGlSelectClose() {
      try {
        store.glAccounts = toJS(store.glAccountsStored);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setGlCodesAfterLoad(data) {
      try {
        Object.entries(data).forEach(_ref => {
          let _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          store[key] = value;
          if (key === 'utilityGlAccounts') {
            store.utilityGlAccountsStored = value;
          }
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateGlCode(type, value) {
      try {
        store[type] = value;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateUtilityGlAccounts(utilityId, glId) {
      try {
        const idx = store.utilityGlAccounts.findIndex(i => i.propertyUtilityLivableId === utilityId);
        if (idx !== -1) {
          store.utilityGlAccounts[idx].glAccountExternalId = glId;
        } else {
          store.utilityGlAccounts.push({
            propertyUtilityLivableId: utilityId,
            glAccountExternalId: glId
          });
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    handleUtilityGlAccountsClose() {
      try {
        store.utilityGlAccounts = toJS(store.utilityGlAccountsStored);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    handleUtilityGlAccountsSave() {
      try {
        store.utilityGlAccountsStored = toJS(store.utilityGlAccounts);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    getGlNameByCode(code) {
      try {
        const glName = store.glAccountsStored.find(i => i.externalId === code);
        return glName && glName.name ? glName.name : 'N/A';
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});